var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[_c('div',{class:(_vm.prefixCls + "-carousel")},[_c('Carousel',{attrs:{"carouselData":_vm.swipeList}})],1),_c('notice-announcement'),_c('news-center')],1)}
var staticRenderFns = []

export { render, staticRenderFns }